import React from "react"
import { makeStyles } from "@material-ui/styles"
import TaskCreator from "./TaskCreator"
import ProcessCreator from "./ProcessCreator"
import { CreatorMaster } from "../Creators"

const useStyles = makeStyles((theme) => ({
  actions: {
    marginRight: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
  },
}))

const TemplateCreator = ({ open, onClose, isInline, edit }) => {
  const classes = useStyles()
  const isEdit = edit != null

  const handleOnClose = (event, isCancel) => {
    onClose(isCancel)
  }

  const subject = edit ? edit.__typename : "Process"

  const form = (
    <>
      {edit && edit.__typename === "Task" && (
        <TaskCreator onClose={handleOnClose} isInline={isInline} classes={classes} edit={edit} />
      )}
      {(!edit || edit.__typename === "Process") && (
        <ProcessCreator onClose={handleOnClose} isInline={isInline} classes={classes} edit={edit} />
      )}
    </>
  )

  return (
    <CreatorMaster
      open={open}
      subject={subject}
      form={form}
      isEdit={isEdit}
      isInline={isInline}
      onClose={handleOnClose}
    />
  )
}

export { TemplateCreator }
